


import React from 'react'
import { Helmet } from "react-helmet-async";

const OtherServicesPage = () => {
  return (
    <>

    <Helmet>
            <title>
            Property Valuation Division Techno Land –Engineers & Surveyors 
            </title>
        
          </Helmet>
    <div class="rts-banner-area rts-section-gap rts-breadcrumb-area  position-relative contact-bd">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="breadcrumb-area-inner">
                          
                            <h1 class="title">
                           Other Services 
                            </h1>
    
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
       <div class="about-service-main-wrapper rts-section-gap bg_white" id="about">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-xl-5">
                    <div class="thumbnail-main-wrapper-2">
                        <div class="reveal-item overflow-hidden aos-init">
                            <div class="" data-aos="reveal-end">
                            </div>
                            <img src="assets/images/about/s-one.png" alt="journey-area"/>
                        </div>
                    </div>
                </div>
                <div class="col-xl-7 pl--60 pl_md--0 pl_sm--10 pt_md--30 pt_sm--30">
                    <div class="about-content-area-two">
                        <div class="title-style-two-left">
                            <div class="title-left-align-five">
                                <span class="pre">Property Valuation Division</span>
                                <h2 class="title mb--30">Precision in Property Worth – Your Valuation Experts</h2>
                            </div>
                           
                            <p class="disc">
                            We provide reliable property valuation for personal, legal, and commercial use.
                            We offer: </p>
                            <ul>
                                <li>Valuation for sale, mortgage, and redevelopment</li>
                                <li>Market rate and government rate comparison</li>
                                <li>Detailed property reports by certified valuers
                                Our reports are accepted by banks and government institutions.</li>
                            </ul>
                           
                          
                        </div>
                    </div>
                </div>
                
                 <div class="col-xl-7 pl_md--0 pl_sm--10 pt_md--30 pt_sm--30">
                    <div class="about-content-area-two">
                        <div class="title-style-two-left">
                            <div class="title-left-align-five">
                                <span class="pre">Property Valuation Division</span>
                                <h2 class="title mb--30">Precision in Property Worth – Your Valuation Experts</h2>
                            </div>
                           
                            <p class="disc">
                            We provide reliable property valuation for personal, legal, and commercial use.
                            We offer: </p>
                            <ul>
                                <li>Valuation for sale, mortgage, and redevelopment</li>
                                <li>Market rate and government rate comparison</li>
                                <li>Detailed property reports by certified valuers
                                Our reports are accepted by banks and government institutions.</li>
                            </ul>
                           
                          
                        </div>
                    </div>
                </div>
                  <div class="col-xl-5">
                    <div class="thumbnail-main-wrapper-2">
                        <div class="reveal-item overflow-hidden aos-init">
                            <div class="" data-aos="reveal-end">
                            </div>
                            <img src="assets/images/about/s-one.png" alt="journey-area"/>
                        </div>
                    </div>
                </div>
                 <div class="col-xl-5">
                    <div class="thumbnail-main-wrapper-2">
                        <div class="reveal-item overflow-hidden aos-init">
                            <div class="" data-aos="reveal-end">
                            </div>
                            <img src="assets/images/about/s-one.png" alt="journey-area"/>
                        </div>
                    </div>
                </div>
                <div class="col-xl-7 pl--60 pl_md--0 pl_sm--10 pt_md--30 pt_sm--30">
                    <div class="about-content-area-two">
                        <div class="title-style-two-left">
                            <div class="title-left-align-five">
                                <span class="pre">Property Valuation Division</span>
                                <h2 class="title mb--30">Precision in Property Worth – Your Valuation Experts</h2>
                            </div>
                           
                            <p class="disc">
                            We provide reliable property valuation for personal, legal, and commercial use.
                            We offer: </p>
                            <ul>
                                <li>Valuation for sale, mortgage, and redevelopment</li>
                                <li>Market rate and government rate comparison</li>
                                <li>Detailed property reports by certified valuers
                                Our reports are accepted by banks and government institutions.</li>
                            </ul>
                           
                          
                        </div>
                    </div>
                </div>
                   <div class="col-xl-7 pl_md--0 pl_sm--10 pt_md--30 pt_sm--30">
                    <div class="about-content-area-two">
                        <div class="title-style-two-left">
                            <div class="title-left-align-five">
                                <span class="pre">Property Valuation Division</span>
                                <h2 class="title mb--30">Precision in Property Worth – Your Valuation Experts</h2>
                            </div>
                           
                            <p class="disc">
                            We provide reliable property valuation for personal, legal, and commercial use.
                            We offer: </p>
                            <ul>
                                <li>Valuation for sale, mortgage, and redevelopment</li>
                                <li>Market rate and government rate comparison</li>
                                <li>Detailed property reports by certified valuers
                                Our reports are accepted by banks and government institutions.</li>
                            </ul>
                           
                          
                        </div>
                    </div>
                </div>
                  <div class="col-xl-5">
                    <div class="thumbnail-main-wrapper-2">
                        <div class="reveal-item overflow-hidden aos-init">
                            <div class="" data-aos="reveal-end">
                            </div>
                            <img src="assets/images/about/s-one.png" alt="journey-area"/>
                        </div>
                    </div>
                </div>
                 <div class="col-xl-5">
                    <div class="thumbnail-main-wrapper-2">
                        <div class="reveal-item overflow-hidden aos-init">
                            <div class="" data-aos="reveal-end">
                            </div>
                            <img src="assets/images/about/s-one.png" alt="journey-area"/>
                        </div>
                    </div>
                </div>
                <div class="col-xl-7 pl--60 pl_md--0 pl_sm--10 pt_md--30 pt_sm--30">
                    <div class="about-content-area-two">
                        <div class="title-style-two-left">
                            <div class="title-left-align-five">
                                <span class="pre">Property Valuation Division</span>
                                <h2 class="title mb--30">Precision in Property Worth – Your Valuation Experts</h2>
                            </div>
                           
                            <p class="disc">
                            We provide reliable property valuation for personal, legal, and commercial use.
                            We offer: </p>
                            <ul>
                                <li>Valuation for sale, mortgage, and redevelopment</li>
                                <li>Market rate and government rate comparison</li>
                                <li>Detailed property reports by certified valuers
                                Our reports are accepted by banks and government institutions.</li>
                            </ul>
                           
                          
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
           
   
    
     <div class="rts-offer-area-start rts-section-gap">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="title-style-two-center inner">
                        <span class="pre">Smart Development</span>
                        <h2 class="title mb--40">Why Choose Our Property Valuation Services?</h2>
                    </div>
                </div>
            </div>
            <div class="row g-24">
                <div class="col-lg-6 col-md-12 col-12">
                    <div class="single-offer-inner">
                        <a href="#" class="thumbnail">
                            <img src="assets/images/about/work1.png" alt="offer"/>
                        </a>
                        <div class="content-area">
                            <a href="#" class="title">
                                <h5 class="title">High Precision & Accuracy</h5>
                            </a>
                            <p class="disc">
                                We use advanced GPS, GIS, Total Station, and Drone Technology to ensure precise survey results, reducing errors and rework.
                            </p>
                           
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-md-12 col-12">
                    <div class="single-offer-inner">
                        <a href="#" class="thumbnail">
                            <img src="assets/images/about/work1.png" alt="offer"/>
                        </a>
                        <div class="content-area">
                            <a href="#" class="title">
                                <h5 class="title">Comprehensive Solutions</h5>
                            </a>
                            <p class="disc">
                                Our expertise covers topographical surveys, boundary demarcation, contour mapping, and infrastructure planning, catering to diverse project needs.
                            </p>
                           
                        </div>
                    </div>
                </div>
             
               
                <div class="col-lg-6 col-md-12 col-12">
                    <div class="single-offer-inner">
                        <a href="#" class="thumbnail">
                            <img src="assets/images/about/work3.png" alt="offer"/>
                        </a>
                        <div class="content-area">
                            <a href="#" class="title">
                                <h5 class="title">Regulatory Compliance</h5>
                            </a>
                            <p class="disc">
                                We ensure all surveys adhere to local and national regulations, helping clients avoid legal issues and delays.
                            </p>
                           
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-md-12 col-12">
                    <div class="single-offer-inner">
                        <a href="#" class="thumbnail">
                            <img src="assets/images/about/work4.png" alt="offer"/>
                        </a>
                        <div class="content-area">
                            <a href="#" class="title">
                                <h5 class="title">Expertise & Experience</h5>
                            </a>
                            <p class="disc">
                                Our streamlined processes and cutting-edge technology enable faster project execution while maintaining cost efficiency.
                            </p>
                           
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </>
  )
}

export default OtherServicesPage